import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { useClinic, waLink } from "../context/ClinicContext";

export const MobileStickyBar = () => {
  const { phone, whatsapp } = useClinic();
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-slate-200 py-2.5 px-3 grid grid-cols-3 gap-2 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] lg:hidden"
      data-testid="mobile-sticky-bar"
    >
      <a href={`tel:${phone}`} className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-xl bg-[#E8F4FD] text-[#1A75BC] font-semibold text-xs" data-testid="sticky-call">
        <Phone size={19} /> Call
      </a>
      <a href={waLink(whatsapp)} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-xl bg-[#EAFBF1] text-[#27AE60] font-semibold text-xs" data-testid="sticky-whatsapp">
        <MessageCircle size={19} /> WhatsApp
      </a>
      <Link to="/contact" className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-xl gradient-bg text-white font-semibold text-xs" data-testid="sticky-appointment">
        <CalendarCheck size={19} /> Book
      </Link>
    </div>
  );
};

export default MobileStickyBar;
